import * as React from 'react';
import styled from 'styled-components';

export interface ColumnProps {
  children: React.ReactNode | React.ReactNodeArray;
}

const Container = styled.div`
  box-sizing: border-box;
  padding: 0 5px;
  width: 100%;
`;

/**
 * The component wrap content in column
 * @param {ColumnProps} props
 * @return {React.ReactElement<ColumnProps>}
 * @constructor
 */
export default function Column(
    props: ColumnProps,
): React.ReactElement<ColumnProps> {
  return (
    <Container>
      {props.children}
    </Container>
  );
}
